<template>
    <div
        class="outer-box kgr-text kgr-text--extraSmall"
        :class="alignClass"
        style="white-space: pre"
    >
        <a :href="href">
            <kgr-icon icon-class="warning" class="kgr-color--warning" />
            <div class="hint">{{ $t(title) }}</div>
        </a>
    </div>
</template>
<script>
import KgrIcon from './icon/Icon.vue';

export default {
    name: 'kgr-fill-in-link',
    components: {
        KgrIcon
    },
    props: {
        href: {
            type: String,
            required: true,
        },
        align: {
            type: String,
            required: false,
            default: 'left',
        },
        title: {
            type: String,
            required: false,
            default: 'club.member.stocktaking.pleaseComplete'
        },
    },
    computed: {
        alignClass() {
            return 'right' === this.align ? 'kgr-text--rightAligned kgr-float kgr-float--right' : 'kgr-float kgr-float--left margin-right';
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .outer-box {
        height: 1rem;
    }
    .margin-right {
        margin-right: 0.5rem
    }
    .hint {
        display: inline-block;
        position: relative;
        top:-0.35rem;
    }
</style>
